/**
 * @property {number} id
 * @property {number} uuid
 * @property {string} name
 * @property {string} effectiveDate
 * @property {Price} price
 * @property {Price} previousPrice
 * @property {?Period} period
 * @property {{id: string, oldValue: string, newValue: string}[]} attributes
 * @property {boolean} isPriceHidden
 */
export class SummaryItem {
  constructor({
    id,
    uuid,
    name,
    effectiveDate,
    price,
    previousPrice,
    period,
    attributes,
    isPriceHidden,
  }) {
    this.id = id;
    this.uuid = uuid;
    this.name = name;
    this.effectiveDate = effectiveDate;
    this.price = price;
    this.previousPrice = previousPrice;
    this.period = period;
    this.attributes = attributes;
    this.isPriceHidden = isPriceHidden;
  }
}
